import Effects from "showhide"
import windows from "@/core/windows"
import page from "@/core/page"
import settings from "@/core/settings"
import measurePerformance from "@/core/measurePerformance"
import { toObjectKeys } from "@/utils/object"
import { injectStaticCampaign } from "./injection"
import subscribeIntersectionObserver from "./async/intersection"
import subscribeMutationObserver from "./async/mutation"
import { cssEscape } from "./selector"
import { wrapAsync } from "@/utils/wrapAsync"

const effects = new Effects()

export function getPlacementsForInjection() {
  return page.selectAll(".nosto_element:not(.nosto-dynamic)").map(node => node.id)
}

export function getPlacements() {
  const intersectionObservedDivIds = toObjectKeys(settings.intersectionObserved)
  const mutationObservedDivIds = toObjectKeys(settings.mutationObserved)
  // do not use `Array.from(array_like, function)` as there are not up-to-spec polyfills in the wild
  // that ignore the second parameter
  const res = page
    .selectAll(".nosto_element")
    .filter(node => {
      // placement is present on the page, no need to track with mutation observer
      delete mutationObservedDivIds[node.id]
      // skip the static placements that has `nosto_lazy` class and are not visible on the page currently
      // and be loaded lazily via `subscribeIntersectionObserver`
      return !subscribeIntersectionObserver(node, node.id, {
        intersection: node.classList.contains("nosto_lazy") || intersectionObservedDivIds[node.id]
      })
    })
    .map(node => node.id)
  Object.keys(mutationObservedDivIds).forEach(divId => {
    subscribeMutationObserver(divId, {
      mutation: true,
      cssSelector: cssEscape`#${divId}.nosto_element`,
      intersection: intersectionObservedDivIds[divId]
    })
  })

  return res
}

export function injectCampaigns(campaigns: Record<string, string>) {
  return measurePerformance("nosto.inject_static_campaigns", () => {
    return Promise.all(
      Object.keys(campaigns)
        .map(key => {
          const value = campaigns[key]
          // noinspection TypeScriptValidateTypes
          const div = page.select(cssEscape`#${key}:not(.nosto-dynamic)`)
          if (div) {
            return wrapAsync<[string, HTMLElement[]]>(() => {
              injectStaticCampaign(div, value, key)
              effects.show(div, windows.site)
              return [key, [div]]
            })
          }
          return undefined
        })
        .filter(Boolean)
    )
  })
}
